import { Plugin } from 'prosemirror-state';

function KeydownEvents(handlers) {
   return new Plugin({
      props: {
         handleKeyDown: function(...args) {
            return handlers.reduce((last, curr) => {
               if (!last) {
                  return curr.apply(null, args);
               } else {
                  return last;
               }
            }, false);
         },
      },
   });
}

export default KeydownEvents;
